import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import LikeIcon from './icons/Like';

const SwiperFooter = ({ favoritesCount, handleGoToFavorites }) => (
  <div
    role="button"
    tabIndex={0}
    className="swiper-footer"
    onClick={handleGoToFavorites}
  >
    <span className="swiper-footer__favorites-text">
      {trans('search.matcher.swipe.go-favorites')}
    </span>
    <span className="swiper-footer__favorites-count">
      <strong>{favoritesCount} </strong>
      <LikeIcon small className="swiper-footer__favorites-count-icon" />
    </span>
  </div>
);

SwiperFooter.propTypes = {
  favoritesCount: PropTypes.number.isRequired,
  handleGoToFavorites: PropTypes.func.isRequired
};

export default SwiperFooter;
